<template>
  <div class="self-start">
    <div v-if="slots.banner" class="z-48 sm:top-(--headerHeight)">
      <slot name="banner" />
    </div>
    <slot />
  </div>
  <DpaNewsFooter :has-disclaimer="true" />
</template>

<script setup lang="ts">
import DpaNewsFooter from "@/components/shared/DpaNewsFooter/DpaNewsFooter.vue";

const slots = defineSlots<{
  banner: any;
  default: any;
}>();
</script>
